import FooterFr from 'components/FooterFr'
import MobileFooterFr from 'components/MobileFooterFr';
import MobileNavbarFr from 'components/MobileNavbarFr';
import NavbarFr from 'components/NavbarFr'
import PublicationsListFr from 'components/Publications/PublicationListFr';
import React from 'react';
import { useSelector } from 'react-redux';
import { useEffect } from "react";

function PublicationsFr() {
  const isMobile = useSelector(state => state.windowSize.isMobile);
  
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <PublicationsListFr />
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <PublicationsListFr />
      <FooterFr />
      </>
    )}
    </>
  )
}

export default PublicationsFr